import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonComponent } from '@shared/components/btn/button.component';

@Component({
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, ButtonComponent],
  selector: 'esp-modal-confirmar-generico',
  templateUrl: './modal-confirmar-generico.component.html',
  styleUrls: ['./modal-confirmar-generico.component.scss']
})
export class ModalConfirmarGenericoComponent {
  titulo: string = '';
  message: string = ''
  botonCancelar: string = ''
  botonOk: string = ''
  constructor(@Inject(DIALOG_DATA) public data      : any,
 
  private _dialogRef                    : MatDialogRef<any>) {
    this.message = data.message || 'Mensaje de Confirmación'
    this.titulo = data.titulo || 'Confirmación'
    this.botonCancelar = data.botonCancelar || 'Cancelar'
    this.botonOk = data.botonOk || 'Confirmar'
}

ngOnInit(){
//console.log(this.data);
}

onClose(){
this._dialogRef.close({success: false});
}

okBtn(){
  this._dialogRef.close({success: true});
}
}
